import PageNotFoundImg from "../../assets/images/404_image.png";

export default {
  "page_not_found_txt": "The page you have accessed does not exist.",
  "error_code": "404",
  "Pagenotfound_img": PageNotFoundImg,
  "Pagenotfound_alt": "Page Not Found",
  "return_home_txt": "Return To Home"
};